import { useTranslation } from 'react-i18next'

const MISTRAL_CGU_URL = import.meta.env.VITE_MISTRAL_CGU_URL ?? 'https://legal.mistral.ai/terms'
const EBIM_AI_URL = import.meta.env.VITE_EBIM_AI_URL ?? 'https://ebim.ai'
const CONTACT_EBIM_AI_EMAIL = import.meta.env.VITE_CONTACT_EBIM_AI_EMAIL ?? 'rgpd@ebim.ai'

export function CguPage() {
  const { t } = useTranslation()

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <article className="mx-auto w-full max-w-[738px] px-4 py-10">
        <h1 className="text-foreground mb-6 text-center text-[30px] font-bold">
          {t('cguPage.title')}
        </h1>
        <p className="text-foreground mb-4 text-base font-normal italic">{t('cguPage.version')}</p>

        <section className="mb-8">
          <h2 className="text-foreground mb-4 text-base font-bold">{t('cguPage.section1Title')}</h2>
          <p className="text-legal-body text-base font-normal">{t('cguPage.section1Body')}</p>
          <p className="text-legal-body text-base font-normal">
            {t('cguPage.section1ConfirmIntro')}
          </p>
          <ul className="text-legal-body list-inside list-disc pl-2 text-base font-normal">
            <li>{t('cguPage.section1List1')}</li>
            <li>{t('cguPage.section1List2')}</li>
            <li>
              {t('cguPage.section1List3Prefix')}
              <a
                href={MISTRAL_CGU_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary underline hover:opacity-90"
              >
                {t('cguPage.section1List3Link')}
              </a>
              {t('cguPage.section1List3Suffix')}
            </li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-foreground mb-4 text-base font-bold">{t('cguPage.section2Title')}</h2>
          <h3 className="text-foreground mb-4 text-base font-bold">
            {t('cguPage.section2_1Title')}
          </h3>
          <p className="text-legal-body text-base font-normal">{t('cguPage.section2_1Body')}</p>
          <ul className="text-legal-body list-inside list-disc pl-2 text-base font-normal">
            <li>{t('cguPage.section2_1List1')}</li>
            <li>{t('cguPage.section2_1List2')}</li>
            <li>{t('cguPage.section2_1List3')}</li>
          </ul>
          <h3 className="text-foreground mt-4 mb-4 text-base font-bold">
            {t('cguPage.section2_2Title')}
          </h3>
          <ul className="text-legal-body list-inside list-disc pl-2 text-base font-normal">
            <li>{t('cguPage.section2_2List1')}</li>
            <li>{t('cguPage.section2_2List2')}</li>
          </ul>
          <p className="text-legal-body mt-2 text-base font-bold">
            {t('cguPage.section2_2Prohibitions')}
          </p>
          <ul className="text-legal-body list-inside list-disc pl-2 text-base font-normal">
            <li>{t('cguPage.section2_2ProhibitionsList1')}</li>
            <li>{t('cguPage.section2_2ProhibitionsList2')}</li>
            <li>{t('cguPage.section2_2ProhibitionsList3')}</li>
            <li>{t('cguPage.section2_2ProhibitionsList4')}</li>
            <li>{t('cguPage.section2_2ProhibitionsList5')}</li>
          </ul>
          <h3 className="text-foreground mt-4 mb-4 text-base font-bold">
            {t('cguPage.section2_3Title')}
          </h3>
          <p className="text-legal-body text-base font-normal">{t('cguPage.section2_3Intro')}</p>
          <ul className="text-legal-body list-inside list-disc pl-2 text-base font-normal">
            <li>{t('cguPage.section2_3List1')}</li>
            <li>{t('cguPage.section2_3List2')}</li>
          </ul>
          <h2 className="text-foreground my-4 text-base font-bold">{t('cguPage.section3Title')}</h2>
          <p className="text-legal-body text-base font-normal">
            {t('cguPage.section3BodyPrefix')}
            <a href={EBIM_AI_URL} className="text-primary underline hover:opacity-90">
              {t('cguPage.section3BodyLink')}
            </a>
          </p>
          <p className="text-legal-body text-base font-normal">
            {t('cguPage.section3PriceChange')}
          </p>
          <h2 className="text-foreground my-4 text-base font-bold">{t('cguPage.section4Title')}</h2>
          <h3 className="text-foreground mb-4 text-base font-bold">
            {t('cguPage.section4_1Title')}
          </h3>
          <p className="text-legal-body text-base font-normal">{t('cguPage.section4_1Body')}</p>
          <h3 className="text-foreground my-4 text-base font-bold">
            {t('cguPage.section4_2Title')}
          </h3>
          <p className="text-legal-body text-base font-normal">{t('cguPage.section4_2Body')}</p>
          <h3 className="text-foreground my-4 text-base font-bold">
            {t('cguPage.section4_3Title')}
          </h3>
          <p className="text-legal-body text-base font-normal">{t('cguPage.section4_3Intro')}</p>
          <ul className="text-legal-body list-inside list-disc pl-2 text-base font-normal">
            <li>{t('cguPage.section4_3List1')}</li>
            <li>
              {t('cguPage.section4_3List2Prefix')}
              <a
                href={`mailto:${CONTACT_EBIM_AI_EMAIL}`}
                className="text-primary underline hover:opacity-90"
              >
                {CONTACT_EBIM_AI_EMAIL}
              </a>
              {t('cguPage.section4_3List2Suffix')}
            </li>
          </ul>
          <h2 className="text-foreground my-4 text-base font-bold">{t('cguPage.section5Title')}</h2>
          <h3 className="text-foreground my-4 text-base font-bold">
            {t('cguPage.section5_1Title')}
          </h3>
          <ul className="text-legal-body list-inside list-disc pl-2 text-base font-normal">
            <li>{t('cguPage.section5_1List1')}</li>
            <li>{t('cguPage.section5_1List2')}</li>
            <li>{t('cguPage.section5_1List3')}</li>
            <li>{t('cguPage.section5_1List4')}</li>
          </ul>
          <h3 className="text-foreground my-4 text-base font-bold">
            {t('cguPage.section5_2Title')}
          </h3>
          <ul className="text-legal-body list-inside list-disc pl-2 text-base font-normal">
            <li>{t('cguPage.section5_2List1')}</li>
            <li>
              {t('cguPage.section5_2List2Prefix')}
              <a
                href={`mailto:${CONTACT_EBIM_AI_EMAIL}`}
                className="text-primary underline hover:opacity-90"
              >
                {CONTACT_EBIM_AI_EMAIL}
              </a>
              {t('cguPage.section5_2List2Suffix')}
            </li>
          </ul>
          <h2 className="text-foreground my-4 text-base font-bold">{t('cguPage.section6Title')}</h2>
          <h3 className="text-foreground my-4 text-base font-bold">
            {t('cguPage.section6_1Title')}
          </h3>
          <p className="text-legal-body text-base font-normal">{t('cguPage.section6_1Intro')}</p>
          <ul className="text-legal-body list-inside list-disc pl-2 text-base font-normal">
            <li>{t('cguPage.section6_1List1')}</li>
          </ul>
          <p className="text-legal-body text-base font-normal">{t('cguPage.section6_1Body')}</p>
          <h3 className="text-foreground my-4 text-base font-bold">
            {t('cguPage.section6_2Title')}
          </h3>
          <ul className="text-legal-body list-inside list-disc pl-2 text-base font-normal">
            <li>{t('cguPage.section6_2List1')}</li>
            <li>{t('cguPage.section6_2List2')}</li>
          </ul>
          <h3 className="text-foreground my-4 text-base font-bold">
            {t('cguPage.section6_3Title')}
          </h3>
          <p className="text-legal-body text-base font-normal">{t('cguPage.section6_3Body')}</p>
          <ul className="text-legal-body list-inside list-disc pl-2 text-base font-normal">
            <li>{t('cguPage.section6_3List1')}</li>
            <li>{t('cguPage.section6_3List2')}</li>
            <li>{t('cguPage.section6_3List3')}</li>
            <li>{t('cguPage.section6_3List4')}</li>
            <li>{t('cguPage.section6_3List5')}</li>
          </ul>
          <p className="text-legal-body text-base font-normal">{t('cguPage.section6_3Footer')}</p>
          <h2 className="text-foreground my-4 text-base font-bold">{t('cguPage.section7Title')}</h2>
          <p className="text-legal-body text-base font-normal">{t('cguPage.section7Intro')}</p>
          <ul className="text-legal-body list-inside list-disc pl-2 text-base font-normal">
            <li>{t('cguPage.section7List1')}</li>
            <li>{t('cguPage.section7List2')}</li>
          </ul>
          <h2 className="text-foreground my-4 text-base font-bold">{t('cguPage.section8Title')}</h2>
          <p className="text-legal-body text-base font-normal">{t('cguPage.section8Body')}</p>
          <h2 className="text-foreground my-4 text-base font-bold">{t('cguPage.section9Title')}</h2>
          <p className="text-legal-body text-base font-normal">{t('cguPage.section9Intro')}</p>
          <ul className="text-legal-body list-inside list-disc pl-2 text-base font-normal">
            <li>{t('cguPage.section9List1')}</li>
            <li>{t('cguPage.section9List2')}</li>
            <li>{t('cguPage.section9List3')}</li>
          </ul>
          <h2 className="text-foreground my-4 text-base font-bold">
            {t('cguPage.section10Title')}
          </h2>
          <p className="text-legal-body text-base font-normal">{t('cguPage.section10Body')}</p>

          <h2 className="text-foreground my-4 text-base font-bold">
            {t('cguPage.section11Title')}
          </h2>
          <p className="text-legal-body text-base font-normal">{t('cguPage.section11Body')}</p>

          <h2 className="text-foreground my-4 text-base font-bold">
            {t('cguPage.section12Title')}
          </h2>
          <p className="text-legal-body text-base font-normal">
            {t('cguPage.section12Prefix')}
            <a
              href={`mailto:${CONTACT_EBIM_AI_EMAIL}`}
              className="text-primary underline hover:opacity-90"
            >
              {CONTACT_EBIM_AI_EMAIL}
            </a>
          </p>

          <h2 className="text-foreground my-4 mt-18 text-center text-[30px] font-bold">
            {t('cguPage.cgvTitle')}
          </h2>
          <p className="text-legal-body text-base font-normal">{t('cguPage.cgvEditor')}</p>
          <p className="text-legal-body text-base font-normal">{t('cguPage.cgvLastUpdate')}</p>

          <h3 className="text-foreground mt-4 mb-4 text-base font-bold">
            {t('cguPage.cgvSection1Title')}
          </h3>
          <p className="text-legal-body text-base font-normal">{t('cguPage.cgvSection1Body')}</p>

          <h3 className="text-foreground mt-4 mb-4 text-base font-bold">
            {t('cguPage.cgvSection2Title')}
          </h3>
          <p className="text-legal-body text-base font-normal">{t('cguPage.cgvSection2Body')}</p>

          <h3 className="text-foreground mt-4 mb-4 text-base font-bold">
            {t('cguPage.cgvSection3Title')}
          </h3>
          <ul className="text-legal-body list-inside list-disc pl-2 text-base font-normal">
            <li>{t('cguPage.cgvSection3List1')}</li>
            <li>{t('cguPage.cgvSection3List2')}</li>
            <li>{t('cguPage.cgvSection3List3')}</li>
          </ul>

          <h3 className="text-foreground mt-4 mb-4 text-base font-bold">
            {t('cguPage.cgvSection4Title')}
          </h3>
          <ul className="text-legal-body list-inside list-disc pl-2 text-base font-normal">
            <li>{t('cguPage.cgvSection4List1')}</li>
            <li>{t('cguPage.cgvSection4List2')}</li>
            <li>{t('cguPage.cgvSection4List3')}</li>
            <li>{t('cguPage.cgvSection4List4')}</li>
          </ul>

          <h3 className="text-foreground mt-4 mb-4 text-base font-bold">
            {t('cguPage.cgvSection5Title')}
          </h3>
          <ul className="text-legal-body list-inside list-disc pl-2 text-base font-normal">
            <li>{t('cguPage.cgvSection5List1')}</li>
            <li>{t('cguPage.cgvSection5List2')}</li>
            <li>{t('cguPage.cgvSection5List3')}</li>
          </ul>

          <h3 className="text-foreground mt-4 mb-4 text-base font-bold">
            {t('cguPage.cgvSection6Title')}
          </h3>
          <ul className="text-legal-body list-inside list-disc pl-2 text-base font-normal">
            <li>{t('cguPage.cgvSection6List1')}</li>
            <li>{t('cguPage.cgvSection6List2')}</li>
          </ul>

          <h3 className="text-foreground mt-4 mb-4 text-base font-bold">
            {t('cguPage.cgvSection7Title')}
          </h3>
          <ul className="text-legal-body list-inside list-disc pl-2 text-base font-normal">
            <li>{t('cguPage.cgvSection7List1')}</li>
            <li>{t('cguPage.cgvSection7List2')}</li>
          </ul>

          <h3 className="text-foreground mt-4 mb-4 text-base font-bold">
            {t('cguPage.cgvSection8Title')}
          </h3>
          <ul className="text-legal-body list-inside list-disc pl-2 text-base font-normal">
            <li>{t('cguPage.cgvSection8List1')}</li>
            <li>
              {t('cguPage.cgvSection8List2Prefix')}
              <a
                href="https://ebim.ai/discover"
                className="text-primary underline hover:opacity-90"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('cguPage.cgvSection8List2Link')}
              </a>
              {t('cguPage.cgvSection8List2Suffix')}
            </li>
          </ul>

          <h3 className="text-foreground mt-4 mb-4 text-base font-bold">
            {t('cguPage.cgvSection9Title')}
          </h3>
          <p className="text-legal-body text-base font-normal">{t('cguPage.cgvSection9Body')}</p>

          <h3 className="text-foreground mt-4 mb-4 text-base font-bold">
            {t('cguPage.cgvSection10Title')}
          </h3>
          <p className="text-legal-body text-base font-normal">{t('cguPage.cgvSection10Body')}</p>

          <h3 className="text-foreground mt-4 mb-4 text-base font-bold">
            {t('cguPage.cgvSection11Title')}
          </h3>
          <ul className="text-legal-body list-inside list-disc pl-2 text-base font-normal">
            <li>{t('cguPage.cgvSection11List1')}</li>
            <li>{t('cguPage.cgvSection11List2')}</li>
          </ul>
        </section>
      </article>
    </div>
  )
}
